import * as actions from "./actionsTypes";

const initialData = {
  loaderEvalFormCompetency: false,
  evalFormCompetency: null,
  evalFormCompetencyFalla: null,
  saveLoaderEvalFormCompetency: false,
  evalFormCompetencyFormError:null,
};

export default function EvalFormCompetencyReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_FORMULARIO_COMPETENCIA:
      return { ...state, loaderEvalFormCompetency: action.payload };

    case actions.GET_FORMULARIO_COMPETENCIA:
      return { ...state, evalFormCompetency: action.payload };

    case actions.FORMULARIO_COMPETENCIA_FALLA:
      return { ...state, evalFormCompetencyFalla: action.payload };

    case actions.SAVE_LOADER_FORMULARIO_COMPETENCIA:
      return { ...state, saveLoaderEvalFormCompetency: action.payload };

    case actions.FORM_FORMULARIO_COMPETENCIA_FAIL:
      return { ...state, evalFormCompetencyFormError: action.payload };
      
    default:
      return state;
  }
}
